/* NOPAL LIFE — Bloc « Votre parcours Académie » après le diagnostic (relie diagnostic ↔ graphe Académie).
   Lecture seule du profil (localStorage nopal_diagnostics) — aucune modif du diagnostic (D6). */
(function () {
  var PARC = {
    debutante: ['academie-parcours-debutante', 'Débuter en soin de la peau'],
    sensible: ['academie-parcours-peau-sensible', 'Peau sensible & réactive'],
    mature: ['academie-parcours-peau-mature', 'Peau mature & fermeté'],
    eclat: ['academie-parcours-eclat-taches', 'Éclat & taches'],
    imperfections: ['academie-parcours-imperfections-adultes', "Imperfections de l'adulte"],
    minimaliste: ['academie-parcours-routine-minimaliste', 'Routine minimaliste'],
    figue: ['academie-parcours-figue-de-barbarie', "L'Institut Figue de Barbarie"],
  };
  function pick(rec) {
    var t = (rec.skinType || '').toLowerCase();
    var c = (rec.topConcerns || []).map(function (x) { return String(x).toLowerCase(); }).join(',');
    if (/sensib/.test(t) || /sensib/.test(c)) return PARC.sensible;
    if (/matur/.test(t) || /rides|relach|fermet/.test(c)) return PARC.mature;
    if (/tache|eclat|terne|pigment/.test(c)) return PARC.eclat;
    if (/grasse/.test(t) || /imperfection|bouton|pore|acn/.test(c)) return PARC.imperfections;
    if (/eclat|normale/.test(t)) return PARC.eclat;
    return PARC.debutante;
  }
  function latest() { try { var a = JSON.parse(localStorage.getItem('nopal_diagnostics') || '[]'); return a.length ? a[a.length - 1] : null; } catch (e) { return null; } }

  function render() {
    if (document.getElementById('nlc-acad-parcours')) return true;
    var rec = latest(); if (!rec) return false;
    var p = pick(rec), anchor = document.querySelector('[data-nlc="dossier-btn"], #nlc-dossier-btn, a[href="/pages/mon-dossier-peau"]');
    var el = document.createElement('div');
    el.id = 'nlc-acad-parcours';
    el.style.cssText = 'max-width:680px;margin:24px auto;padding:22px;border:1px solid rgba(184,146,63,.4);border-radius:16px;background:linear-gradient(135deg,rgba(184,146,63,.10),rgba(184,146,63,.02));font-family:Inter,system-ui,sans-serif;text-align:center';
    el.innerHTML =
      '<div style="font:600 11px/1 Inter,sans-serif;letter-spacing:.18em;color:#b8923f;text-transform:uppercase;margin-bottom:6px">Pour aller plus loin</div>' +
      '<h3 style="font-family:Spectral,Georgia,serif;font-size:24px;color:#2c2a26;margin:0 0 6px;font-weight:600">Votre parcours Académie : ' + p[1] + '</h3>' +
      '<p style="font-size:14px;color:#6b655c;margin:0 0 16px">Comprenez votre peau en profondeur grâce au parcours pédagogique adapté à votre profil.</p>' +
      '<a href="/pages/' + p[0] + '" style="display:inline-block;background:#b8923f;color:#fff;text-decoration:none;font-weight:600;padding:13px 26px;border-radius:30px;margin:0 6px 8px">Suivre mon parcours</a>' +
      '<a href="/pages/academie-de-la-peau" style="display:inline-block;color:#6b5e3a;text-decoration:none;font-weight:600;padding:13px 18px">Explorer toute l\'Académie</a>';
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(el, anchor);
    else { var res = document.getElementById('step-results') || document.body; res.appendChild(el); }
    return true;
  }
  var t0 = (new Date()).getTime();
  (function loop() { if (render()) return; if ((new Date()).getTime() - t0 < 12 * 60000) setTimeout(loop, 1500); })();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
})();
